document.addEventListener('DOMContentLoaded', function () {
    const carousel = document.querySelector('.carousel');
    const items = document.querySelectorAll('.carousel__item');
    const section = document.querySelector('.lock-scroll-video');
    const totalItems = items.length;
    const anglePerItem = 360 / totalItems;
    let currentAngle = 0;
    let currentIndex = 0;
    let isScrollLocked = false;
    let lastScrollTime = 0;
    const scrollDebounceTime = 800; // Should match the CSS transition duration

    // Touch variables
    let startY = 0;
    let endY = 0;
    const touchThreshold = 50; // Minimum distance required to consider it a swipe

    // Position each item around the circle (vertical rotation)
    items.forEach((item, index) => {
        const angle = index * anglePerItem;
        item.style.transform = `rotateX(${angle}deg) translateZ(300px)`; // Adjust translateZ for distance
    });

    function lockScroll() {
        document.body.style.overflow = 'hidden';
        isScrollLocked = true;
    }

    function unlockScroll() {
        document.body.style.overflow = '';
        isScrollLocked = false;
    }

    function handleScroll(event) {
        if (!isScrollLocked) {
            return;
        }

        const now = Date.now();

        if (now - lastScrollTime < scrollDebounceTime) {
            event.preventDefault();
            return;
        }

        const delta = event.deltaY;

        if (delta > 0 && currentIndex < totalItems - 1) {
            // Scrolling down
            currentIndex++;
            currentAngle = currentIndex * anglePerItem; // Remove negative sign
            carousel.style.transform = `translateY(0) translateZ(-300px) rotateX(${currentAngle}deg)`;
        } else if (delta < 0 && currentIndex > 0) {
            // Scrolling up
            currentIndex--;
            currentAngle = currentIndex * anglePerItem; // Remove negative sign
            carousel.style.transform = `translateY(0) translateZ(-300px) rotateX(${currentAngle}deg)`;
        } else {
            // Unlock scroll when reaching the end or beginning
            unlockScroll();
            // Do not remove the 'wheel' event listener here
        }

        lastScrollTime = now;
        event.preventDefault();
    }

    // Handle touch events for mobile
    function handleTouchStart(event) {
        if (!isScrollLocked) {
            return;
        }
        startY = event.touches[0].clientY;
    }

    function handleTouchMove(event) {
        if (!isScrollLocked) {
            return;
        }
        endY = event.touches[0].clientY;
    }

    function handleTouchEnd(event) {
        if (!isScrollLocked) {
            return;
        }

        const now = Date.now();

        if (now - lastScrollTime < scrollDebounceTime) {
            event.preventDefault();
            return;
        }

        const deltaY = startY - endY;

        if (Math.abs(deltaY) > touchThreshold) {
            if (deltaY > 0 && currentIndex < totalItems - 1) {
                // Swiping up
                currentIndex++;
                currentAngle = currentIndex * anglePerItem; // Remove negative sign
                carousel.style.transform = `translateY(0) translateZ(-300px) rotateX(${currentAngle}deg)`;
            } else if (deltaY < 0 && currentIndex > 0) {
                // Swiping down
                currentIndex--;
                currentAngle = currentIndex * anglePerItem; // Remove negative sign
                carousel.style.transform = `translateY(0) translateZ(-300px) rotateX(${currentAngle}deg)`;
            } else {
                // Unlock scroll when reaching the end or beginning
                unlockScroll();
                // Do not remove the touch event listeners here
            }
            lastScrollTime = now;
            event.preventDefault();
        }
    }

    function checkSectionPosition() {
        const rect = section.getBoundingClientRect();
        const sectionMiddle = rect.top + rect.height / 2;
        const viewportMiddle = window.innerHeight / 2;

        // Engage scroll lock when the section's middle is within 50 pixels of the viewport's middle
        if (Math.abs(sectionMiddle - viewportMiddle) <= 50) {
            if (!isScrollLocked) {
                lockScroll();
                window.addEventListener('wheel', handleScroll, { passive: false });

                // Add touch event listeners for mobile
                window.addEventListener('touchstart', handleTouchStart, { passive: false });
                window.addEventListener('touchmove', handleTouchMove, { passive: false });
                window.addEventListener('touchend', handleTouchEnd, { passive: false });
            }
        } else {
            if (isScrollLocked) {
                unlockScroll();
                window.removeEventListener('wheel', handleScroll);

                // Remove touch event listeners for mobile
                window.removeEventListener('touchstart', handleTouchStart);
                window.removeEventListener('touchmove', handleTouchMove);
                window.removeEventListener('touchend', handleTouchEnd);
            }
        }
    }

    // Initial setup
    carousel.style.transform = `translateY(0) translateZ(-300px) rotateX(0deg)`; // Set initial position

    // Listen to scroll events to check position
    window.addEventListener('scroll', checkSectionPosition);
    // Run the check on page load in case the section is already in position
    checkSectionPosition();
});





/* lock-scroll-content.js */

(function() {
  document.addEventListener('DOMContentLoaded', function() {
    // Find all elements with class 'lock-scroll-content'
    var lockScrollSections = document.querySelectorAll('.lock-scroll-content');

    lockScrollSections.forEach(function(section) {
      var headlines = section.querySelectorAll('.headline');
      var descriptions = section.querySelectorAll('.description');
      var images = section.querySelectorAll('.slide-image');
      var progressCounter = section.querySelector('.progress-counter');

      var numSlides = headlines.length;
      var currentSlide = 0;

      // Update progress counter
      updateProgressCounter();

      // Add click event listeners to headlines
      headlines.forEach(function(headline, index) {
        headline.addEventListener('click', function() {
          currentSlide = index;
          updateActiveClasses();
          updateProgressCounter();
        });
      });

      // For mobile devices, add swipe functionality
      addSwipeListener(section);

      function updateActiveClasses() {
        // Update headlines
        headlines.forEach(function(item, index) {
          if (index === currentSlide) {
            item.classList.add('active');
          } else {
            item.classList.remove('active');
          }
        });

        // Update descriptions
        descriptions.forEach(function(item, index) {
          if (index === currentSlide) {
            item.classList.add('active');
          } else {
            item.classList.remove('active');
          }
        });

        // Update images
        images.forEach(function(item, index) {
          if (index === currentSlide) {
            item.classList.add('active');
          } else {
            item.classList.remove('active');
          }
        });
      }

      function updateProgressCounter() {
        if (progressCounter) {
          progressCounter.textContent = (currentSlide + 1) + '/' + numSlides;
        }
      }

      // Initial activation
      updateActiveClasses();

      // Swipe functionality for mobile devices
      function addSwipeListener(element) {
        var touchstartX = 0;
        var touchendX = 0;
        var touchThreshold = 50; // Minimum swipe distance in pixels

        element.addEventListener('touchstart', function(event) {
          touchstartX = event.changedTouches[0].screenX;
        }, false);

        element.addEventListener('touchend', function(event) {
          touchendX = event.changedTouches[0].screenX;
          handleGesture();
        }, false);

        function handleGesture() {
          var swipeDistance = touchendX - touchstartX;

          if (Math.abs(swipeDistance) > touchThreshold) {
            if (swipeDistance < 0) {
              // Swipe left - Next slide
              if (currentSlide < numSlides - 1) {
                currentSlide++;
                updateActiveClasses();
                updateProgressCounter();
              }
            } else {
              // Swipe right - Previous slide
              if (currentSlide > 0) {
                currentSlide--;
                updateActiveClasses();
                updateProgressCounter();
              }
            }
          }
        }
      }
    });
  });
})();



document.addEventListener('DOMContentLoaded', function () {
    const sections = document.querySelectorAll('.lock-scroll-content', '.lock-scroll-video');

    sections.forEach(section => {
        const items = section.querySelectorAll('.scroll-item');
        const progressCounter = section.querySelector('.progress-counter');

        // Group each slide set (headline, description, image) based on data-slide attribute
        const slideGroups = [...section.querySelectorAll('.scroll-item[data-slide]')].reduce((acc, item) => {
            const slideIndex = item.getAttribute('data-slide');
            acc[slideIndex] = acc[slideIndex] || [];
            acc[slideIndex].push(item);
            return acc;
        }, {});

        let currentSlide = 0;
        const totalSlides = Object.keys(slideGroups).length;
        const scrollSensitivity = 10; // Minimum delta to detect intentional scroll
        const scrollDebounceTime = 500; // Debounce time in milliseconds

        let isScrollingLocked = false;
        let isSectionActive = false;
        let isScrolling = false;
        let lastScrollTime = 0;

        function lockScroll() {
            document.body.style.overflow = 'hidden';
            isScrollingLocked = true;
        }

        function unlockScroll() {
            document.body.style.overflow = '';
            isScrollingLocked = false;
        }

        function updateSlide(index) {
            // Remove active class from all elements in each group
            Object.values(slideGroups).forEach(group => {
                group.forEach(item => item.classList.remove('active'));
            });

            // Add active class to the current group
            const currentGroup = slideGroups[index];
            if (currentGroup) {
                currentGroup.forEach(item => item.classList.add('active'));
            }

            // Update the counter display if it exists
            if (progressCounter) {
                progressCounter.textContent = `${index + 1}/${totalSlides}`;
            }
        }

        function handleScroll(event) {
            const now = Date.now();

            if (!isScrollingLocked || isScrolling || now - lastScrollTime < scrollDebounceTime) {
                return;
            }

            const delta = event.deltaY;

            // Ignore small, accidental movements
            if (Math.abs(delta) < scrollSensitivity) {
                return;
            }

            isScrolling = true;
            lastScrollTime = now;

            if (delta > 0 && currentSlide < totalSlides - 1) {
                // Scroll down to next slide if available
                currentSlide++;
                updateSlide(currentSlide);
            } else if (delta < 0 && currentSlide > 0) {
                // Scroll up to previous slide if available
                currentSlide--;
                updateSlide(currentSlide);
            } else if (delta > 0 && currentSlide === totalSlides - 1) {
                // If on the last slide and scrolling down, unlock scroll
                unlockScroll();
                window.removeEventListener('wheel', handleScroll);
            } else if (delta < 0 && currentSlide === 0) {
                // If on the first slide and scrolling up, unlock scroll
                unlockScroll();
                window.removeEventListener('wheel', handleScroll);
            }

            setTimeout(() => {
                isScrolling = false;
            }, 350);
        }

        // Intersection Observer to toggle scroll lock
        const observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    lockScroll();
                    isSectionActive = true;
                    window.addEventListener('wheel', handleScroll);
                } else if (isSectionActive) {
                    unlockScroll();
                    window.removeEventListener('wheel', handleScroll);
                    isSectionActive = false;
                }
            });
        }, { threshold: 1 }); 

        observer.observe(section);

        // Initialize counter on load if counter exists
        if (progressCounter) {
            progressCounter.textContent = `1/${totalSlides}`;
        }

        // Set initial slide to active
        updateSlide(currentSlide);
    });
});



